import EDocketForm from 'views/edocket/EDocketForm';
import { Route } from '../ProtectedRoute';

const eDocketRoutes: Route[] = [
    {
        path: 'edocket/create',
        name: 'CreateEDocket',
        element: <EDocketForm />,
    },
];

export default eDocketRoutes;
